import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_themeBase/layout";
import * as auth from "../_redux/authRedux";
import { logout } from "../_redux/authCrud";


class Logout extends Component {
  componentDidMount() {
    logout()
      .then((res) => {
        this.props.logout();
      })
      .catch((err) => {
        window.localStorage.clear();
        window.sessionStorage.clear();
        window.location.replace("/auth/login");
      });
  }

  render() {
    const { hasAuthToken } = this.props;
    return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth/login" />;
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken), user: auth.user }),
  auth.actions
)(Logout);
